import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetCasualActiveTabs, setCasualFormUpdateActions } from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";

const CasualRefernceDetails = ({ propsID }) => {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();

    const initialRow = {
        name: "",
        email: "",
        phone: "",
    };

    const [referenceList, setReferenceList] = useState([
        { name: "", email: "", phone: "" },
    ]);

    const relationshipOptions = [
        "Friend",
        "Colleague",
        "Manager",
        "Relative",
        "Professional",
        "Other",
    ];

    useEffect(() => {
        if (state.CasualApproveRequestDatas?.Inquriy) {
            const responseData = state.CasualApproveRequestDatas.Inquriy;
            const refData =
                responseData?.reference_details ||
                responseData?.references ||
                responseData?.reference;

            if (Array.isArray(refData) && refData.length > 0) {
                // Clone objects to avoid mutating read-only Redux state objects
                setReferenceList(refData.map((item) => ({ ...item })));
            }
        }
    }, [state.CasualApproveRequestDatas?.Inquriy]);

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        setReferenceList((prevList) =>
            prevList.map((item, i) =>
                i === index ? { ...item, [name]: value } : item
            )
        );
    };

    const handlePhoneChange = (index, value) => {
        const val = value.replace(/[^0-9]/g, "");
        if (val.length <= 10) {
            setReferenceList((prevList) =>
                prevList.map((item, i) =>
                    i === index ? { ...item, phone: val } : item
                )
            );
        }
    };

    const handleAddMore = () => {
        setReferenceList((prevList) => [...prevList, { ...initialRow }]);
    };

    const handleRemoveRow = (index) => {
        if (referenceList.length > 1) {
            setReferenceList((prevList) => prevList.filter((_, i) => i !== index));
        } else {
            setReferenceList([{ ...initialRow }]);
        }
    };
    const navigate = useNavigate()
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Reference Details Data:", referenceList);
    };

    const HandleSaveNext = () => {
        const payload = {
            id: propsID,
            data: {
                reference: referenceList
            },
            Functions: () => {
                navigate(`/casualemployeeprofile/${propsID}`)

            }
        }
        dispatch(setCasualFormUpdateActions(payload))
    }

    return (
        <div className="BodyContent">
            <div className="card">
                <div className="card-body cards">
                    <div className="UserPoup">
                        <div className="BeforForms">
                            <div className="Form">
                                <div
                                    className="ModalHeader"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        <span>Reference Details</span>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn ButtonCSS"
                                        style={{
                                            color: "#fff",
                                            background: "#234492",
                                        }}
                                        onClick={handleAddMore}
                                    >
                                        + Add More
                                    </button>
                                </div>

                                <div className="Modal-Body ModalForms">
                                    {referenceList.map((item, index) => (
                                        <div
                                            key={index}
                                            className="row align-items-center mb-3 pb-3"
                                            style={{
                                                borderBottom:
                                                    index < referenceList.length - 1
                                                        ? "1px solid #eee"
                                                        : "none",
                                            }}
                                        >
                                            {/* Name - Text Field */}
                                            <div className="col-sm-4 mt-3">
                                                <label className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    name="name"
                                                    placeholder="Enter Name"
                                                    value={item.name || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>

                                            {/* Email - Email Field */}
                                            <div className="col-sm-4 mt-3">
                                                <label className="form-label">Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    name="email"
                                                    placeholder="Enter Email"
                                                    value={item.email || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>

                                            {/* Phone - Number Field */}
                                            <div className="col-sm-3 mt-3">
                                                <label className="form-label">Phone Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    name="phone"
                                                    maxLength={10}
                                                    placeholder="Enter Phone Number"
                                                    value={item.phone || ""}
                                                    onChange={(e) =>
                                                        handlePhoneChange(index, e.target.value)
                                                    }
                                                />
                                            </div>

                                            {/* Delete / Remove Action */}
                                            <div className="col-sm-1 mt-4 text-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm mt-2"
                                                    title="Remove"
                                                    onClick={() => handleRemoveRow(index)}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        </div>
                                    ))}

                                    <div
                                        className="RoleButton"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            padding: "15px 0 0",
                                            marginTop: "20px",
                                        }}
                                    >
                                        {state.CasualApproveRequestDatas.Inquriy?.is_pending &&

                                            <button
                                                type="button"
                                                className="btn ButtonCSS"
                                                style={{
                                                    color: "#fff",
                                                    background: "#234492",
                                                }}
                                                onClick={HandleSaveNext}
                                            >
                                                Save & Finish
                                            </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CasualRefernceDetails;